import { connect } from 'react-redux';
import {
  closeSupportWindow,
  getSupportNextNumber,
  // eslint-disable-next-line import/named
  delSupportNumber,
  supportGetListPhotos,
  supportAddPhoto,
  supportDelPhoto,
  supportSendEmail
} from '../../store/actions/support';
import SupportForm from './SupportForm';

const mapStateToProps = ({
  supportReducer,
  userReducer
}) => ({
  supportReducer,
  userReducer
});

export default connect(mapStateToProps, {
  closeSupportWindow,
  getSupportNextNumber,
  delSupportNumber,
  supportGetListPhotos,
  supportAddPhoto,
  supportDelPhoto,
  supportSendEmail
})(SupportForm);
